// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3tQfT","row":"Node_row__2dxba","label":"Node_label__2oeH6","footer":"Node_footer__IOqdg"};